const persistentSessionKey = "SESSION";
const handler = {
    SET_SESSION: (o, n) => {
        try {
            if (typeof localStorage !== "undefined") {
                if (n && n.accessToken) localStorage.setItem(persistentSessionKey, JSON.stringify({accessToken: n.accessToken}));
                else localStorage.removeItem(persistentSessionKey);
            }
        } catch (_) { /* In-memory login must still work when storage is unavailable. */ }
        return Object.assign({}, n);
    }
};

export default function sessionReducer(session = null, action) {
    if(handler[action.type]) {
        return handler[action.type](session, action.value);
    }
    return session;
}
